/* eslint-disable react-hooks/rules-of-hooks */
"use client";
import useGetToken from "@/hooks/useGetToken";
import { NavItem } from "@/types/interface";
import {
  CalendarClock,
  DockIcon,
  File,
  HandHelping,
  Image,
  LayoutDashboard,
  Map,
  MapPinned,
  Monitor,
  Package,
  Table2,
  View,
} from "lucide-react";

export const BASE_URL = process.env.NEXT_PUBLIC_API_URL;
export const REGION_URL = process.env.NEXT_PUBLIC_API_REGION;
export const GEO_JSON_URL = process.env.NEXT_PUBLIC_GEO_JSON_URL;

type navDateType = {
  navItems: NavItem[];
};

export const getNavData = (): navDateType => {
  return {
    navItems: [
      {
        title: "Dashboard",
        url: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        title: "Form Input",
        url: "/form-input",
        icon: DockIcon,
        items: [
          {
            title: "Semua Input",
            url: "/form-input/all",
          },
          {
            title: "Surat",
            url: "/form-input/letter",
          },
        ],
      },
      {
        title: "Tables",
        url: "/tables",
        icon: Table2,
        items: [
          {
            title: "tables admin",
            url: "/tables/admin",
          },
        ],
      },
      {
        title: "Maps View",
        url: "/maps",
        icon: Map,
      },
      {
        title: "Images",
        url: "/images",
        icon: Image,
      },
      {
        title: "View Label",
        url: "/view-label",
        icon: View,
      },
    ],
  };
};

export const getNavDataAdmin = (): navDateType => {
  const { decode } = useGetToken();
  const role = decode?.roleType;
  return {
    navItems: [
      {
        title: "Dashboard",
        url: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        title: "GIS",
        url: "/gis",
        icon: MapPinned,
      },

      ...(role === "P3B"
        ? [
            {
              title: "Data Pengajuan",
              url: "/submission/initial-submission",
              icon: HandHelping,
            },
          ]
        : [
            {
              title: "Pengajuan",
              url: "/submission",
              icon: HandHelping,
              items: [
                {
                  title: "Data Pengajuan",
                  url: "/submission/initial-submission",
                },
                {
                  title: "Data Perpanjangan",
                  url: "/submission/extend-submission",
                },
                {
                  title: "Data Ditolak",
                  url: "/submission/rejected-submission",
                },
              ],
            },
            {
              title: "Pengembalian",
              url: "/return-submission",
              icon: CalendarClock,
              items: [
                {
                  title: "Pengembalian",
                  url: "/return-submission/initial-return",
                },
                {
                  title: "Pengembalian Ditolak",
                  url: "/return-submission/rejected-return",
                },
              ],
            },
          ]),

      {
        title: "Monitoring",
        url: "/monitoring",
        icon: Monitor,
      },
      {
        title: "Aset",
        url: "/assets",
        icon: Package,
      },
      {
        title: "Laporan",
        url: "/reports",
        icon: File,
      },
    ],
  };
};
